import { render, staticRenderFns } from "./home-banner.vue?vue&type=template&id=10637358&scoped=true&"
import script from "./home-banner.vue?vue&type=script&lang=js&"
export * from "./home-banner.vue?vue&type=script&lang=js&"
import style0 from "./home-banner.vue?vue&type=style&index=0&id=10637358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10637358",
  null
  
)

export default component.exports